import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';
import './styles/animations.css';
import { ToastProvider } from './components/ui/Toast';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import BottomNav from './components/ui/BottomNav';
import PageTransition from './components/ui/PageTransition';
import HomePage from './pages/HomePage';
import WrongAnswerNote from './pages/WrongAnswerNote';
import RecordList from './pages/RecordList';
import SnapPage from './pages/SnapPage';
import RecordDetail from './pages/RecordDetail';
import ApiKeysPage from './pages/ApiKeysPage';
import ExpertMarketplace from './pages/ExpertMarketplace';
import ScenarioBuilder from './pages/ScenarioBuilder';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'var(--gradient-bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: 'var(--font-size-lg)',
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            {/* 홈은 누구나 접근 가능 (로그인 여부에 따라 다르게 표시) */}
            <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
            {/* /login은 홈으로 리다이렉트 */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            {/* 나머지는 로그인 필요 */}
            <Route path="/snap/:scenarioId" element={<PrivateRoute><PageTransition><SnapPage /></PageTransition></PrivateRoute>} />
            <Route path="/register" element={<PrivateRoute><PageTransition><WrongAnswerNote /></PageTransition></PrivateRoute>} />
            <Route path="/records" element={<PrivateRoute><PageTransition><RecordList /></PageTransition></PrivateRoute>} />
            <Route path="/records/:recordId" element={<PrivateRoute><PageTransition><RecordDetail /></PageTransition></PrivateRoute>} />
            <Route path="/settings/api-keys" element={<PrivateRoute><PageTransition><ApiKeysPage /></PageTransition></PrivateRoute>} />
            <Route path="/experts" element={<PrivateRoute><PageTransition><ExpertMarketplace /></PageTransition></PrivateRoute>} />
            <Route path="/scenario-builder" element={<PrivateRoute><PageTransition><ScenarioBuilder /></PageTransition></PrivateRoute>} />
          </Routes>
          <BottomNav />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
